export default class UserPayload {
  constructor(
    public first_name: string,
    public last_name: string,
    public email: string,
    public password: string,
    public challenge?: boolean
  ) {}
}
